import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// Plugins
import './plugins/axios';
import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';
import './plugins/modal';
// Register service worker for PWA support
import './registerServiceWorker';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app');

